var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "menuToggle" } }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.isActive,
          expression: "isActive",
        },
      ],
      attrs: { type: "checkbox" },
      domProps: {
        checked: Array.isArray(_vm.isActive)
          ? _vm._i(_vm.isActive, null) > -1
          : _vm.isActive,
      },
      on: {
        change: function ($event) {
          var $$a = _vm.isActive,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_vm.isActive = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_vm.isActive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isActive = $$c
          }
        },
      },
    }),
    _vm._v(" "),
    _c("span"),
    _vm._v(" "),
    _c("span"),
    _vm._v(" "),
    _c("span"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }